module.exports = "<a class=\"fa fa-info\" ng-click=ctrl.getInfo()></a> ";